import { Droppable, Draggable } from "@hello-pangea/dnd";
import { useSelector, useDispatch } from "react-redux";
import {
  setLeftSearch,
  setRightSearch,
} from "../../store/reducers/phraseBuilder/phraseBuilder.slice";
import { useMemo } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

const PhraseList = () => {
  const dispatch = useDispatch();
  const {
    leftWord,
    rightWord,
    leftSearch,
    rightSearch,
    leftPhrases,
    rightPhrases,
  } = useSelector((s) => s.phraseBuilder);

  const filteredLeftPhrases = useMemo(() => {
    if (!leftPhrases || leftPhrases.length === 0) return [];
    return leftPhrases
      .filter((p) => p.frase.toLowerCase().includes(leftSearch.toLowerCase()))
      .map((p) => ({
        id: p.id,
        text: p.frase,
        side: "left",
        draggableId: `left-${p.id}`,
      }));
  }, [leftPhrases, leftSearch]);

  const filteredRightPhrases = useMemo(() => {
    if (!rightPhrases || rightPhrases.length === 0) return [];
    return rightPhrases
      .filter((p) => p.frase.toLowerCase().includes(rightSearch.toLowerCase()))
      .map((p) => ({
        id: p.id,
        text: p.frase,
        side: "right",
        draggableId: `right-${p.id}`,
      }));
  }, [rightPhrases, rightSearch]);

  return (
    <div className="row mt-4 g-4">
      {/* Izquierda */}
      <div className="col-12 col-md-6">
        <div className="card border-0 shadow-sm h-100">
          <div className="card-body">
            <div className="d-flex align-items-center gap-2 mb-3 fw-semibold">
              <Icon icon="mdi:format-list-bulleted" width={20} />
              Frases izquierda
            </div>

            <div className="input-group mb-3">
              <span className="input-group-text bg-white">
                <Icon icon="mdi:magnify" width={18} />
              </span>
              <input
                className="form-control"
                placeholder="Buscar frase..."
                onChange={(e) => dispatch(setLeftSearch(e.target.value))}
              />
            </div>

            <Droppable droppableId="leftPhrases">
              {(prov) => (
                <div
                  ref={prov.innerRef}
                  {...prov.droppableProps}
                  style={{
                    maxHeight: 260,
                    overflowY: "auto",
                    paddingRight: 4,
                  }}
                  className="pe-1"
                >
                  {filteredLeftPhrases.map((p, i) => (
                    <Draggable
                      key={p.draggableId}
                      draggableId={JSON.stringify(p)}
                      index={i}
                    >
                      {(prov) => (
                        <div
                          ref={prov.innerRef}
                          {...prov.draggableProps}
                          {...prov.dragHandleProps}
                          className="card border-0 shadow-sm p-2 mb-2 d-flex align-items-center gap-2"
                        >
                          <Icon icon="mdi:drag" width={18} />
                          {p.text}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {prov.placeholder}
                </div>
              )}
            </Droppable>
          </div>
        </div>
      </div>

      {/* Derecha */}
      <div className="col-12 col-md-6">
        <div className="card border-0 shadow-sm h-100">
          <div className="card-body">
            <div className="d-flex align-items-center gap-2 mb-3 fw-semibold">
              <Icon icon="mdi:format-list-bulleted-square" width={20} />
              Frases derecha
            </div>

            <div className="input-group mb-3">
              <span className="input-group-text bg-white">
                <Icon icon="mdi:magnify" width={18} />
              </span>
              <input
                className="form-control"
                placeholder="Buscar frase..."
                onChange={(e) => dispatch(setRightSearch(e.target.value))}
              />
            </div>

            <Droppable droppableId="rightPhrases">
              {(prov) => (
                <div
                  ref={prov.innerRef}
                  {...prov.droppableProps}
                  style={{
                    maxHeight: 260,
                    overflowY: "auto",
                    paddingRight: 4,
                  }}
                  className="pe-1"
                >
                  {filteredRightPhrases.map((p, i) => (
                    <Draggable
                      key={p.draggableId}
                      draggableId={JSON.stringify(p)}
                      index={i}
                    >
                      {(prov) => (
                        <div
                          ref={prov.innerRef}
                          {...prov.draggableProps}
                          {...prov.dragHandleProps}
                          className="card border-0 shadow-sm p-2 mb-2 d-flex align-items-center gap-2"
                        >
                          <Icon icon="mdi:drag" width={18} />
                          {p.text}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {prov.placeholder}
                </div>
              )}
            </Droppable>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhraseList;
